<div class="content-wrapper u-space-v_30">
  <app-dog-summary-card
    [dogId]="dogId"
    page="milestones"
  ></app-dog-summary-card>
</div>

<div class="content-wrapper milestone-stepper_wrapper u-space-v_30">
  <h2 class="mat-display-medium">Milestones</h2>
  @if (!hasData) {
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  }
  @if (hasData) {
    <mat-accordion [multi]="true" class="according-stepper">
      @for (milestone of milestones; track milestone; let i = $index) {
        <div
          id="milestone_{{ milestone.id }}"
          class="milestone-stepper_step {{
            milestone.active ? '' : 'disabled'
          }}"
          >
          <div class="milestone-stepper_step-icon">
            <img src="{{ milestone.icon }}" alt="{{ milestone.title }}" />
          </div>
          <mat-expansion-panel
            [expanded]="true"
            (opened)="setStep(milestone.id)"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span
                  class="mat-body-medium"
                  [ngClass]="{ incomplete: !milestone.active }"
                  >{{ milestone.title }}</span
                  >
                </mat-panel-title>
              </mat-expansion-panel-header>
              {{ milestone.description }}
            </mat-expansion-panel>
          </div>
        }
      </mat-accordion>
    }
  </div>
